import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
export function ProductGrid() {
  const categories = [{
    name: 'Tecnología',
    products: [{
      name: 'Smartphone Samsung',
      price: '$299',
      image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=300&h=300&fit=crop'
    }, {
      name: 'Tablet Android',
      price: '$189',
      image: 'https://images.unsplash.com/photo-1561154464-82e9adf32764?w=300&h=300&fit=crop'
    }, {
      name: 'Auriculares Bluetooth',
      price: '$45',
      image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=300&h=300&fit=crop'
    }]
  }, {
    name: 'Hogar',
    products: [{
      name: 'Ventilador de Torre',
      price: '$65',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=300&fit=crop'
    }, {
      name: 'Juego de Sábanas',
      price: '$35',
      image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=300&h=300&fit=crop'
    }, {
      name: 'Set de Toallas',
      price: '$28',
      image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=300&h=300&fit=crop'
    }]
  }, {
    name: 'Cocina',
    products: [{
      name: 'Batidora Eléctrica',
      price: '$42',
      image: 'https://images.unsplash.com/photo-1570222094114-d054a817e56b?w=300&h=300&fit=crop'
    }, {
      name: 'Set de Ollas',
      price: '$78',
      image: 'https://images.unsplash.com/photo-1584990347449-39b4aa02d0f9?w=300&h=300&fit=crop'
    }, {
      name: 'Cafetera',
      price: '$55',
      image: 'https://images.unsplash.com/photo-1517668808822-9ebb02f2a0e6?w=300&h=300&fit=crop'
    }]
  }, {
    name: 'Moda',
    products: [{
      name: 'Zapatillas Deportivas',
      price: '$68',
      image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=300&h=300&fit=crop'
    }, {
      name: 'Jeans Premium',
      price: '$45',
      image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=300&h=300&fit=crop'
    }, {
      name: 'Camisetas Pack x3',
      price: '$32',
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=300&h=300&fit=crop'
    }]
  }];
  return <section id="tienda" className="w-full bg-white py-16 md:py-24" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="text-center mb-12" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-163">
            Nuestra Tienda
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-164">
            Miles de productos para enviar a Cuba
          </p>
        </div>

        {categories.map((category, catIndex) => <div key={catIndex} className="mb-16 last:mb-0" data-id="element-165">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-red-600 pl-4" data-id="element-166">
              {category.name}
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-167">
              {category.products.map((product, prodIndex) => <Card key={prodIndex} hover data-id="element-168">
                  <div className="overflow-hidden rounded-t-xl" data-id="element-169">
                    <img src={product.image} alt={product.name} className="w-full h-64 object-cover transition-transform duration-300 hover:scale-110" data-id="element-170" />
                  </div>

                  <div className="p-6" data-id="element-171">
                    <h4 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-172">
                      {product.name}
                    </h4>
                    <div className="text-2xl font-bold text-red-600 mb-4" data-id="element-173">
                      {product.price}
                    </div>
                    <Button variant="primary" className="w-full" data-id="element-174">
                      Agregar al carrito
                    </Button>
                  </div>
                </Card>)}
            </div>
          </div>)}

        <div className="text-center mt-12" data-id="element-175">
          <Button variant="secondary" className="text-lg px-8" data-id="element-176">
            Ver todos los productos
          </Button>
        </div>
      </div>
    </section>;
}